import loadable from '@loadable/component';
import React from 'react';

import * as loaderNames from '../../consts/loader/loaderNames';
import LoadableComponentLoader from '../LoaderGlobal/LoadableComponentLoader';

// IA: webpackChunkName - this is webpack magic comment,
//     it is used to merge multiple components into one chunk
//
// lazy-chunk.s8e - Standalone version only pages(s8e - standalone)
// lazy-chunk.c5t - (c5t - connect)

const AgeGatePage = loadable(() => import(/* webpackChunkName: "lazy-chunk.s8e" */ '../AgeGatePage/AgeGatePage'));
const AgeVerificationFailedPage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.s8e" */ '../AgeVerificationFailedPage/AgeVerificationFailedPage')
);
const BenefitPage = loadable(() => import(/* webpackChunkName: "lazy-chunk.c5t" */ '../BenefitPage/BenefitPage'));
const AppIntroPage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.comp_intro" */ '../BrowserCompatibility/AppIntroPage/AppIntroPage')
);
const ImportantPage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.comp_intro" */ '../ImportantPage/ImportantPage')
);
const NotCompatibleBrowserPage = loadable(() =>
    import(
        /* webpackChunkName: "lazy-chunk.comp_notComp" */ '../BrowserCompatibility/NotCompatibleBrowserPage/NotCompatibleBrowserPage'
    )
);
const CleaningGuidePage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../CleaningGuidePages/CleaningGuidePage')
);
const ConnectionGuidePage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../ConnectionGuidePage/ConnectionGuidePage')
);
const DeviceActivationPage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../DeviceActivationPage/DeviceActivationPage')
);
const DeviceRegistrationPage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../DeviceRegistrationPage/DeviceRegistrationPage')
);
const DeviceSyncPage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../DeviceSyncPage/DeviceSyncPage')
);
const PreferenceCenterSettingsPage = loadable(() =>
    import(
        /* webpackChunkName: "lazy-chunk.c5t" */ '../DeviceSettingsPage/components/PreferenceCenterSettingsPage/PreferenceCenterSettingsPage'
    )
);
const ErrorHandlingPage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../ErrorHandlingPage/ErrorHandlingPage')
);
const LegalDisclaimerPage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../LegalDisclaimerPage/LegalDisclaimerPage')
);
const LoginPage = loadable(() => import(/* webpackChunkName: "lazy-chunk.s8e" */ '../LoginPage/LoginPage'));
const MyDevicesPage = loadable(
    () =>
        import(
            /* webpackPrefetch: true */
            /* webpackChunkName: "lazy-chunk.c5t" */
            '../MyDevicesPage/MyDevicesPage'
        ),
    {
        fallback: <LoadableComponentLoader name={loaderNames.DEVICE_LIST_LOADER} delay={200} />,
    }
);
const NoDevicesPage = loadable(() => import(/* webpackChunkName: "lazy-chunk.c5t" */ '../NoDevicesPage/NoDevicesPage'));
const PairingAlertPage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../PairingAlertPage/PairingAlertPage')
);
const PairingGuidePage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../PairingGuidePage/PairingGuidePage')
);
const PairingSuccessPage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../PairingSuccessPage/PairingSuccessPage')
);
const ResetDevicePage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../ResetDevicePage/ResetDevicePage')
);
const SelectMarketPage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.s8e" */ '../SelectMarketPage/SelectMarketPage')
);
const SelectYourDevicePage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../SelectYourDevicePage/SelectYourDevicePage')
);

const HomePage = loadable(() => import(/* webpackChunkName: "lazy-chunk.c5t" */ '../HomePage/HomePage'));

//TODO: remove
const TipsAndTricksPage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.s8e" */ '../TipsAndTricksPage/TipsAndTricksPage')
);
const TipsAndTutorialsPage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../TipsAndTutorials/TipsAndTutorialsPage')
);
const QuickStartGuidePage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../TipsAndTutorials/QuickStartGuidePage')
);
const WelcomeUserPage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.s8e" */ '../WelcomeUserPage/WelcomeUserPage')
);

const UpdateCheckingPage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../UpdateCheckingPage/UpdateCheckingPage')
);
const UpdateSummaryPage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../UpdateSummaryPage/UpdateSummaryPage')
);
const UpdateFWPage = loadable(() => import(/* webpackChunkName: "lazy-chunk.c5t" */ '../UpdateFWPage/UpdateFWPage'));
const UpToDatePage = loadable(() => import(/* webpackChunkName: "lazy-chunk.c5t" */ '../UpToDatePage/UpToDatePage'));
const UpToDateFailedPage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../UpToDateFailedPage/UpToDateFailedPage')
);
const ConnectionSelectionPage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../ConnectionSelectionPage/ConnectionSelectionPage')
);

const DeviceSettingsPage = loadable(() =>
    import(/* webpackChunkName: "lazy-chunk.c5t" */ '../DeviceSettingsPage/DeviceSettingsPage')
);

export default {
    AgeGatePage,
    AgeVerificationFailedPage,
    AppIntroPage,
    ImportantPage,
    BenefitPage,
    CleaningGuidePage,
    ConnectionGuidePage,
    ConnectionSelectionPage,
    DeviceActivationPage,
    DeviceRegistrationPage,
    DeviceSettingsPage,
    DeviceSyncPage,
    ErrorHandlingPage,
    LegalDisclaimerPage,
    LoginPage,
    MyDevicesPage,
    HomePage,
    NoDevicesPage,
    NotCompatibleBrowserPage,
    PairingAlertPage,
    PairingGuidePage,
    PairingSuccessPage,
    PreferenceCenterSettingsPage,
    QuickStartGuidePage,
    ResetDevicePage,
    SelectMarketPage,
    SelectYourDevicePage,
    TipsAndTricksPage,
    TipsAndTutorialsPage,
    UpdateCheckingPage,
    UpdateFWPage,
    UpdateSummaryPage,
    UpToDateFailedPage,
    UpToDatePage,
    WelcomeUserPage,
};
